import { createContext } from 'react'

import { DesktopNotificationProviderClient } from './DesktopNotificationProviderClient.js'
import type { DesktopNotification } from './types.js'

export const DesktopNotificationContext = createContext<DesktopNotification>({
  status: 'default',
  context: null,
  enabled: false,
  enable: () => {
    return Promise.resolve(false)
  },
  disable: () => {
    return Promise.resolve()
  },
})

interface Props {
  children: React.ReactNode
}

export const DesktopNotificationProvider = ({ children }: Props) => {
  return (
    <DesktopNotificationProviderClient>
      {children}
    </DesktopNotificationProviderClient>
  )
}
